import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AdapterFormBase } from '../adapter-form-base.interface';
import { SplunkAdapterConfig } from 'src/app/services/httpServices/adaptersHttpService/adapters-http.service';
import { uuidValidator, httpsUrlValidator, CREDENTIAL_PLACEHOLDER } from '../validators/adapter-validators';

@Component({
  selector: 'app-splunk-adapter-form',
  templateUrl: './splunk-adapter-form.component.html',
  styleUrls: ['./splunk-adapter-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SplunkAdapterFormComponent implements OnInit, AdapterFormBase {
  @Input() isEditMode = false;

  public adapterForm!: FormGroup;

  constructor(private readonly _fb: FormBuilder) {}

  ngOnInit(): void {
    this._initializeForm();
  }

  private _initializeForm(): void {
    // In edit mode, credential is optional (only required if changing it)
    const hecTokenValidators = this.isEditMode
      ? [uuidValidator('HEC Token', this.isEditMode)]
      : [Validators.required, uuidValidator('HEC Token', this.isEditMode)];

    this.adapterForm = this._fb.group({
      hecUrl: ['', [Validators.required, httpsUrlValidator('HEC URL')]],
      hecToken: ['', hecTokenValidators],
      index: ['', [Validators.required]],
    });
  }

  public initializeForm(data: SplunkAdapterConfig): void {
    if (data) {
      this.adapterForm.patchValue({
        hecUrl: data.hecUrl,
        hecToken: CREDENTIAL_PLACEHOLDER, // Show placeholder, don't expose actual token
        index: data.index,
      });
    }
  }

  public getFormValue(): Partial<SplunkAdapterConfig> {
    const formValue = this.adapterForm.value;
    const config: Partial<SplunkAdapterConfig> = {
      adapterType: 'splunk',
    };

    if (formValue.hecUrl != null && formValue.hecUrl.trim() !== '') {
      config.hecUrl = formValue.hecUrl;
    }
    // Only include hecToken if it's not the placeholder (user changed it)
    if (
      formValue.hecToken != null &&
      formValue.hecToken.trim() !== '' &&
      formValue.hecToken !== CREDENTIAL_PLACEHOLDER
    ) {
      config.hecToken = formValue.hecToken;
    }
    if (formValue.index != null && formValue.index.trim() !== '') {
      config.index = formValue.index;
    }

    return config;
  }

  public isValid(): boolean {
    return this.adapterForm.valid;
  }
}
